import React, { useContext, useState } from "react";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import Spinner from "../../../Component/Spinner";
import { AuthContext } from "../../../contexts/AuthProvider";

const Buyer = () => {
  const { user, loading } = useContext(AuthContext);
  const [booking, setBooking] = useState([]);

  const url = `https://bike-resell-server-hasanalibd.vercel.app/bookings?email=${user?.email}`;

  const { data: bookings = [], refetch } = useQuery({
    queryKey: ["bookings", user?.email],
    queryFn: async () => {
      const res = await fetch(url);
      const data = await res.json();
      return data;
    },
  });

  //   order delete api
  const handleDelete = (booking) => {
    const agree = window.confirm(
      `Are you sure you want to delete: ${booking.model}`
    );
    if (agree) {
      // console.log('deleting user with id:', user._id);
      fetch(
        `https://bike-resell-server-hasanalibd.vercel.app/orders/${booking._id}`,
        {
          method: "DELETE",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.deletedCount > 0) {
            const remaingingList = booking.filter(
              (usr) => usr._id !== booking._id
            );
            setBooking(remaingingList);
            toast.warning("Deleted Successfully");
            refetch();
          }
        });
    }
  };

  if (loading) {
    return <Spinner></Spinner>;
  }

  return (
    <div className="mt-10 mx-10">
      <h1 className="text-3xl font-bold text-center text-[#149777]">
        Total orders: {bookings.length}
      </h1>
      <div className="mt-5">
        <div className="overflow-x-auto">
          <table className="table w-full">
            <thead>
              <tr>
                <th>S.R</th>
                <th>Profile</th>
                <th>Product</th>
                <th>Payment</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {bookings.map((booking, i) => (
                <tr key={booking._id}>
                  <th>{1 + i}</th>
                  <th>
                    <div className="avatar">
                      <div className="w-24 rounded-full">
                        <img
                          src={
                            booking.img
                              ? booking.img
                              : "https://placeimg.com/192/192/people"
                          }
                          alt=""
                        />
                      </div>
                    </div>
                  </th>
                  <th>{booking.model}</th>
                  <th>
                    <button className="btn btn-info">Payment</button>
                  </th>
                  <th>
                    <button
                      onClick={() => handleDelete(booking)}
                      className="btn btn-warning"
                    >
                      Delete
                    </button>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Buyer;
